import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pf0031',
    ecrans: ['00-2'],
    params: ['demcleint',
             'annfin']
});
